<template>
    <div class="section-box">
        <el-form inline label-width="90px">
            <el-form-item label="角色名称：">
                <el-input size="medium" v-model="form.RoleName" placeholder="输入关键字搜索" type="text" />
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>

         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="670"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="角色编码" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.RoleCode || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="角色名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.RoleName || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="角色代码" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.RoleID || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.Remark || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="setMenu(scope.row.RoleID)">设置菜单</el-button>
                    <el-button size="mini" type="warning" @click="setFunction(scope.row.RoleID)">设置功能</el-button>
                    <!-- <template v-if="!(typeof(actionData.systemjspz_setmenu) != 'undefined'&&!actionData.systemjspz_setmenu)">
                        <el-button size="mini" type="primary" @click="setMenu(scope.row.RoleID)">设置菜单</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.systemjspz_setfunction) != 'undefined'&&!actionData.systemjspz_setfunction)">
                        <el-button size="mini" type="warning" @click="setFunction(scope.row.RoleID)">设置功能</el-button>
                    </template> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        adminRoleList,            //获取角色列表
    } from "@/service/system";
    import { getActionData } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
                form: {
                    PageNum: 1,
                    PageSize: 20,
                    RoleName: '',   //角色名称
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
        },
        methods: {
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageNum = 1
                this.form.PageSize = val
                this.searchData.PageNum = 1
                this.searchData.PageSize = val
                this.GetAdminRoleList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageNum = val
                this.searchData.PageNum = val
                this.GetAdminRoleList()
            },
            //获取角色
            async GetAdminRoleList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.RoleName && delete data.RoleName
                data.platform = 'pcweb'
                let res = await adminRoleList(data)
                this.listLoading = false
                if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.RoleList
                this.total = res.Data.TotalCount
            },
            //点击设置菜单
            setMenu(id) {
                this.$router.push('/system/setMenu?roleId='+id)
            },
            //点击设置功能
            setFunction(id) {
                this.$router.push('/system/setFunction?roleId='+id)
            }
        }
    };
    // this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
</script>